import dailyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/dailyIntervalConfig";
import monthlyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/monthlyIntervalConfig";
import weeklyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/weeklyIntervalConfig";
import dayjs from "dayjs";
import DurationService from "app/services/DurationService";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

export type granularityItem = typeof toggleItems.Daily;

export const toggleItems = {
    Daily: {
        title: "timegranularity.day.symbol",
        value: GranularityNames.DAILY,
        intervalConfig: dailyIntervalConfig,
        format: "DD MMM",
    },
    Weekly: {
        title: "timegranularity.week.symbol",
        value: GranularityNames.WEEKLY,
        intervalConfig: weeklyIntervalConfig,
        format: "DD MMM",
    },
    Monthly: {
        title: "timegranularity.month.symbol",
        value: GranularityNames.MONTHLY,
        intervalConfig: monthlyIntervalConfig,
        format: "MMM YY",
    },
} satisfies Record<TimeGranularity, Record<string, any>>;

export const timeGranularity = {
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
} as const;

export type TimeGranularity = (typeof timeGranularity)[keyof typeof timeGranularity];

export const resolveTimeGranularity = (duration: string): TimeGranularity => {
    const { from, to, isWindow } = DurationService.getDurationData(duration).raw;
    if (isWindow) {
        return "Daily";
    }
    const monthsDiff = dayjs(to).diff(from, "months");
    if (monthsDiff > 0) {
        return "Monthly";
    }
    return "Weekly";
};
